import { render } from "./App.vue?vue&type=template&id=6c1da298"
const script = {}

import "./App.vue?vue&type=style&index=0&id=6c1da298&lang=less"

import exportComponent from "/home/gibo/development/primakurzyonline.cz-screencast/trunk/lector-code/pko-lector-code-frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__